"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillLinkButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const LinkButton_1 = require("./LinkButton");
exports.PillLinkButton = (0, styled_1.default)(LinkButton_1.LinkButton) `
	border-radius: 20px;
	box-sizing: border-box;
	:after {
		border-radius: 20px;
	}
`;
//# sourceMappingURL=PillLinkButton.js.map